import React from "react";
import { Check } from "lucide-react";

export const Q = ({ children, sub }) => (
  <div className="mb-6">
    <h2 className="font-serif-title text-2xl sm:text-3xl text-[var(--ink)] leading-snug" data-testid="sujets-question">{children}</h2>
    {sub && <p className="text-sm text-[var(--ink-soft)] mt-2 leading-relaxed">{sub}</p>}
  </div>
);

export const Btn = ({ children, onClick, disabled, secondary, testid, className = "" }) => (
  <button onClick={onClick} disabled={disabled} data-testid={testid}
    className={`inline-flex items-center justify-center gap-2 min-h-[48px] px-6 py-3 rounded-full text-sm font-semibold transition-all active:scale-[0.98] disabled:opacity-40 disabled:cursor-not-allowed ${secondary ? "bg-white border border-[var(--border)] text-[var(--ink)] hover:border-[var(--gold)]" : "bg-[var(--gold)] text-white shadow-sm hover:brightness-105"} ${className}`}>
    {children}
  </button>
);

export const Cards = ({ options, value, onSelect, testid }) => (
  <div className="grid sm:grid-cols-2 gap-3" role="radiogroup" data-testid={testid}>
    {options.map((o) => {
      const on = value === o.v;
      return (
        <button key={o.v} role="radio" aria-checked={on} onClick={() => onSelect(o.v)} data-testid={`${testid}-${o.v}`}
          className={`text-left rounded-2xl border-2 p-4 sm:p-5 min-h-[92px] transition-all hover:border-[var(--gold)] ${on ? "border-[var(--gold)] bg-[var(--sand)] shadow-sm" : "border-[var(--border)] bg-white"}`}>
          <div className="flex items-center gap-3 mb-1">
            <span className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${on ? "bg-[var(--gold)] text-white" : "bg-[var(--sand)] text-[var(--gold)]"}`}>{on ? <Check size={16} strokeWidth={3} /> : o.v}</span>
            <span className="font-semibold text-[var(--ink)]">{o.label}</span>
          </div>
          <p className="text-sm text-[var(--ink-soft)] leading-snug pl-11">{o.desc}</p>
        </button>
      );
    })}
  </div>
);

export const Chips = ({ options, values, onToggle, testid }) => (
  <div className="flex flex-wrap gap-2" data-testid={testid}>
    {options.map((o) => {
      const on = values.includes(o);
      return <button key={o} onClick={() => onToggle(o)} aria-pressed={on} data-testid={`${testid}-${o}`} className={`px-4 py-2.5 rounded-full text-sm font-medium border transition-all ${on ? "bg-[var(--ink)] text-white border-[var(--ink)]" : "bg-white text-[var(--ink)] border-[var(--border)] hover:border-[var(--gold)]"}`}>{on ? "✓ " : ""}{o}</button>;
    })}
  </div>
);

export const Progress = ({ steps, current }) => (
  <ol className="flex items-center gap-1.5 flex-wrap mb-6 no-print" data-testid="sujets-progress" aria-label="Progression">
    {steps.map((s, i) => (
      <li key={s} className="flex items-center gap-1.5">
        <span className={`px-3 py-1 rounded-full text-[11px] font-semibold ${i === current ? "bg-[var(--gold)] text-white" : i < current ? "bg-[var(--sand)] text-[var(--gold)]" : "bg-white border border-[var(--border)] text-[var(--ink-soft)]"}`}>{s}</span>
        {i < steps.length - 1 && <span className="text-[var(--ink-soft)] text-xs">→</span>}
      </li>
    ))}
  </ol>
);

export const Niveau = ({ n, score, small }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${small ? "px-2.5 py-1 text-xs" : "px-3.5 py-1.5 text-sm"}`} style={{ background: n.bg, color: n.color }}>
    <span aria-hidden="true">{n.dot}</span> {n.tag}{score != null ? ` · ${score}/16` : ""}
  </span>
);
